<script lang="ts">
  import { onMount } from 'svelte';
  import type { BoardCard } from '$lib/types';
  import { session } from '$lib/state/session.svelte';
  import { locale, t } from '$lib/i18n';
  import { boardSeenDate, boardSeenVisible } from '$lib/utils/boardSeen';
  let { card }: { card: BoardCard } = $props();
  let now = $state(Date.now());
  const seen = $derived(card.last_seen_at || card.first_seen_at);
  onMount(() => {
    const timer = setInterval(() => { now = Date.now(); }, 60_000);
    return () => clearInterval(timer);
  });
</script>

{#if boardSeenVisible(card, session.me) && (seen || card.delivered_at)}
  <span class="mt-1.5 inline-flex rounded-full bg-surface-2 px-2 py-1 text-[11px] text-dark-gray">
    {#if seen}<time datetime={seen} title={new Date(seen).toLocaleString(locale.current, { timeZone: 'Asia/Kolkata', timeZoneName: 'short' })}>{t('board.seen', { date: boardSeenDate(seen, locale.current, now) })}</time>
    {:else}{t('board.delivered')}{/if}
  </span>
{/if}
